function Util() {
}
var Util = new Util();

Util.printPage = function() {
	window.print();
}

Util.loadPage = function(strURL) {
	location.href = strURL;
}

$(document).ready(function() {	
	$(document).click(function(event) {
		// if the popup is open and they click outside it, close it; if they click on the "divOutsidePopup" div then close the popup
		//window.status='Click!' + ($(event.target).hasClass('divOutsidePopup'));
	    if ($(event.target).hasClass('overlay') && !$(event.target).hasClass("safeclose")) {
	    	Util.closePopup();
		}
	});	
	
	$(document).keypress(function(event) {
	  try {
		var code = (event.keyCode ? event.keyCode : event.which); 
		if (code==27) { // ESC
		  	if (!$("body .overlay").last().hasClass("safeclose")) {
		  		Util.closePopup();
		  	}
		}
	  } catch(e) {
	  }
	});
});

Util.showMore = function(divId) {
	$('#' + divId + '_less').hide();
	$('#' + divId + '_more').show();
}

Util.showLess = function(divId) {
	$('#' + divId + '_less').show();
	$('#' + divId + '_more').hide();
}

Util.showPopupAlert = function(strTitle,strMessage) {
	var strHtml = '<div class="popupShadow"><div class="popupTitle">' + 
		'<div style="position:absolute;right:4px;top:4px;"><a onclick="javascript:Util.closePopup()" class="link"><img src="/images/icons/close_popup_window.png" border="0"></a></div>' + 
		'<div style="text-align:center;margin:14px;">' + strTitle + '</div></div>' + 
		'<div class="popupBody" style="padding:15px;">' + strMessage + '</div>' +	
		'<div class="bottomButtonDivPopup">' +	
			'<a onclick="javascript:Util.closePopup()" class="link btn">Close</a>' +	
		'</div>' +
	'</div>';	
	//Util.showPopup = function(strURL, intWidth, strDivName, bModal, bDontCloseExisting) {
	Util.showPopup(null,450,'divPopup2',true,true);
	$('#divPopup2').html(strHtml);
	Util.initPopup();
} 

Util.showPopupMessage = function(strMessage) {
	return Util.showPopupAlert('Confirm',strMessage);
}

Util.showSecondPopup = function(strURL, intWidth, bModal) {
	var strDivName = 'divPopup2';
	var strHtml = 
	'<div class="modalDiv" style="height:' + ($(document).height() - 4) + 'px;"><div class="divOutsidePopup divOutsideSecondPopup"></div>' +
	'<div id="' + strDivName + '" style="position:absolute;text-align:center;left:' + (Math.round($('body').width()/2)-Math.round(intWidth/2)) + 'px;top:' + (Util.scrollTop() + 120) + 'px;width:' + intWidth + 'px;">' +
	'</div>' +
	'</div>';

	$('body').append(strHtml);	
		
	// now request page 1 for the screen, add the "ajax=true" to the request
	if (strURL != null) {
		strURL += (strURL.indexOf('?') > 0 ? '&' : '?') + Util.addRandomToURL('ajax=true');
		$('#' + strDivName).load(strURL,null,function(responseText, textStatus, req) {
			alert('in load callback, responseText: ' + responseText + ', textStatus: ' + textStatus + ', req:' + req);
			// resize the modalDiv in case the popup is taller than the current screen
			Util.initPopup();
		});
	}
	if (bModal) {
		Util.isModalSecondPopup = true;		
	} else {
		Util.isModalSecondPopup = false;
	}
}

Util.showPopup = function(strURL, intWidth, strDivName, bModal, bDontCloseExisting) {
	if (!bDontCloseExisting) {
		Util.closePopup(); // for example, don't close existing popups on "confirm"
		Validator.clearValidations({strFormName:'frmPopup'});			
	}
	if (strDivName === undefined || strDivName == null) {
		strDivName = 'divPopup';
	}
	if (intWidth === undefined || intWidth == null) {
		intWidth = 500;
	}
	// show the modal grey screen
	// put in the box, hit the server between .  position the grey filter at document height-4, otherwise the page will start scrolling on ie
	var strHtml = 
		'<div class="fixed-popup popup">' +
		'<div class="overlay center '+ (bModal ? 'safeclose' : '' )+'">' +
		'<div id="' + strDivName + '" class="popupShadow popup-container centered" style="width:'+intWidth+'px;top: 10%;margin-bottom: 20%;">'+
		'</div>' +
		'</div>';
	/*
	var strHtml = 
	'<div class="modalDiv" style="height:' + ($(document).height() - 4) + 'px;"><div class="divOutsidePopup"></div>' +
	'<div id="' + strDivName + '" style="position:absolute;text-align:center;left:' + (Math.round($('body').width()/2)-Math.round(intWidth/2)) + 'px;top:' + (Util.scrollTop() + 120) + 'px;width:' + intWidth + 'px;">' +
	'</div>' +
	'</div>';
	*/
	$('body').append(strHtml).addClass('noscroll');		
	
	// now request page 1 for the screen, add the "ajax=true" to the request
	if (strURL != null) {
		strURL += (strURL.indexOf('?') > 0 ? '&' : '?') + Util.addRandomToURL('ajax=true');
		$('#' + strDivName).load(strURL,null,function() {
			// resize the modalDiv in case the popup is taller than the current screen
			Util.initPopup();
		});
	}
	if (bModal) {
		Util.isModalPopup = true;		
	} else {
		Util.isModalPopup = false;
	}
}

/**
* resizes the greyed out layer behind the popup in case the popup is taller than the current page's content
*/
Util.initPopup = function() {
	$('.modalDiv').css('height',($(document).height() - 4) + 'px');
	JTS_init(); // initialize any hovers in the popup
}

Util.closePopup = function(strPopupName) {
  $("body .popup").last().remove();
  Util.detectScrollToggle();
}

//used to check if popup is visible, if so disable scrollbars on body and enable them on the popup
Util.detectScrollToggle = function() {
	var disableScroll = ($('.overlay:visible').length >= 1 || $('.fixed-popup').length >= 1);
    if (disableScroll && !$('body').hasClass('noscroll')) {	
		$('body').addClass('noscroll');	
	} else if (!disableScroll) {
		$('body').removeClass('noscroll');
	}
	return;
} 

Util.selectRadioOnMyForm = function(objInput,radioName,valueToPick) {
	var radioArray = objInput.form[radioName];
	if (radioArray !== undefined && radioArray.length > 0) {
		for (var x=0;x<radioArray.length;x++) {
			if (radioArray[x].value==valueToPick) {
				radioArray[x].checked=true;
				return;
			}
		}
	}
	return;
}

Util.selectRadio = function(radioName,valueToPick,strFormName) {
	if (strFormName === undefined) {
		strFormName='frmMain';
	}
	var radioArray = document.forms[strFormName][radioName];
	for (var x=0;x<radioArray.length;x++) {
		if (radioArray[x].value==valueToPick) {
			radioArray[x].checked=true;
			return;
		}
	}
	return;
}

Util.isRadioSelected = function(radioName,valueToCheck,strFormName) {
	if (strFormName === undefined) {
		strFormName='frmMain';
	}
	var selRadio = $('input[name="' + radioName + '"]:checked').val();
	return selRadio == valueToCheck;
	return;
}

//function to return the value of the checked radio button
Util.getSelectedRadio = function(radioName, theForm) {
	if (theForm === undefined) {
		theForm='frmMain';
	}
	var selRadio = $('input[name="' + radioName + '"]:checked').val();
	return selRadio;
}

Util.selectDefaultRadioValue = function(radioName, defaultValue, strFormName) {
	if (strFormName === undefined) {
		strFormName='frmMain';
	}
	var radioValue = document.forms[strFormName][radioName].value
	if (radioValue == undefined || radioValue == '') {
		document.forms[strFormName][radioName].value = defaultValue
	}
}

Util.checkUncheckAllCheckboxes = function(strName, bUncheck, theForm) {
	if (theForm == null) {
		theForm = eval('document.forms[0]');
	}
	var checkArray = theForm[strName];
	if (typeof(checkArray) == 'undefined') {
		return;
	}
	if (typeof(checkArray.length) == 'undefined') {
		checkArray.checked = bUncheck;
		return;
	} else {
		for (var x=0;x<checkArray.length;x++) {
			checkArray[x].checked = bUncheck;
		}
		return;
	}
}

Util.selectDropdownElement = function(id, valueToSelect) {
	var theSelect = document.getElementById(id);
  theSelect.value = valueToSelect;
}

Util.showSelectedOption = function(theSelect,valueToSelect) {
	var length=theSelect.length;
	for (var i=0;i<length;i++) {
		if (theSelect.options[i].value==valueToSelect) {
			theSelect.selectedIndex = i;//options[i].selected=true;
			return;
		}
	}
}

/****************************************************************************************
 * Function     - Function to populate a select with ref data options with a matching parent
 *                Removes all options starting with the indexToRemoveFrom, in case
 *                there's a 'select one' option or something
 * return       - Nothing
 ****************************************************************************************/
Util.populateFilteredRefData = function(type,theSelect,parentId,indexToRemoveFrom) {
    var theArray = allRefData[type];
    if (parentId == null) {
        parentId = '';    
    }
    if (parentId==null || parentId=='') {
        return;
	}    
    if (theArray == null) {
        return;
    }
    var arrSize = theArray.length;

    theSelect.options.length=indexToRemoveFrom;
    var theIndex = indexToRemoveFrom;
    for (x in theArray) {
        if (theArray[x].parentId == parentId) {
            theSelect.options[theIndex++] = new Option(theArray[x].desc,theArray[x].id);
			// console.log("--- " + theArray[x].id + " | " + theArray[x].desc);
        }
    }    
}

Util.escapeQuote = function(strVar) {
	return strVar.replace('\'','\\\'');
}

Util.clearCommasFromNumber = function(objInput) {
	if (objInput !== undefined && objInput.value !== undefined) {
		objInput.value = objInput.value.replace(',','');
		objInput.value = objInput.value.replace('$','');
	}
	return true;
}

Util.hexChars = '0123456789abcdef';

Util.checkTextInTextareas = function() {
	for(i=0; i<document.forms[0].elements.length; i++) {
		if(document.forms[0].elements[i].type=="textarea") {
			document.forms[0].elements[i].value=Util.stringToUnicode(document.forms[0].elements[i].value);
		}
	}
}

Util.stringToUnicode = function(str) {
	convStr = '';
	for (var x = 0;x<str.length;x++) {
		convStr += Util.charToUni(str.charCodeAt(x));
	}
	return convStr;
}

Util.getHex = function(i) {
	return Util.hexChars.charAt(i & 0x0f);
}

Util.hexVal = function(v) {
	return Util.getHex(v >>> 12) + Util.getHex(v >>> 8) + Util.getHex(v >>> 4) + Util.getHex(v);
}

Util.charToUni = function(ch) {
	switch(ch) {
	case 9:
		return ' ';    	
	case 10:
		return '\n';    	
	case 13:
		return '\r';
	case 8211:
		return '-';
	case 8220:
	case 8221:
		return '"';
		break;
	case 8217:
		return "'";
		break;
	case 8226:
		return '-';
		break;
	case 8230:
		return '...';
		break;
	default:
    	return String.fromCharCode(ch);
    	break;
		
	/*
		if (ch < 32 || ch > 126) {
			//alert('check this one!! ' + ch + ': ' + String.fromCharCode(ch) + '!');
			return "\\u" + Util.hexVal(ch);
		}
		else 
			return String.fromCharCode(ch);
	*/
//	alert('ch: ' + ch + ': ' + String.fromCharCode(ch));
//	return String.fromCharCode(ch);

	}
	return;
}


/**
* strWindowName: the target of the action
*/
Util.doAction = function(strAction,doValidation,strFormName,strWindowName) {
	if (strFormName === undefined) {
		strFormName = 'frmMain';
	}

	Util.clearErrors();
  Util.checkTextInTextareas();
    
  if (doValidation && !Validator.isFormValid()) {
		$('.validationError').html(Validator.errorMessage).show();
		return;
	}

	if (strAction != null) {
		// could just want the default action
		document.forms[strFormName].action=strAction;
	}
	
	if (strWindowName) {
		document.forms[strFormName].target=strWindowName;
	}
	
	document.forms[strFormName].submit();

}


Util.submitFormOnEnter = function(event, functionToCall) {
	if (functionToCall == null || typeof(functionToCall) == 'undefined') {
		return;
	}
	var code = 0;
	if (NS4) {
		code = event.which;
	} else {
		code = event.keyCode;
	}
	if (code==13) {
		eval(functionToCall);
	}
}

/**
* The jquery one doesn't handle the case where it's ie 6.01+ and using loose.dtd, always returns 0
*/
Util.scrollTop = function() {
  if (document.documentElement && document.documentElement.scrollTop) {
  	return document.documentElement.scrollTop;
  } else {
	return $(document).scrollTop();
  }
}

Util.addRandomToURL = function(strParamString) {
	return ('date=' + new Date().getTime() + '&' + strParamString); 
}

Util.onAjaxError = function(XMLHttpRequest, textStatus, errorThrown) {
	//alert('error, http: ' + XMLHttpRequest + ' status: ' + textStatus + ' error: ' + errorThrown);	
	// typically only one of textStatus or errorThrown will have info
	Util.showPopup('/pub/ajaxError',300);
}	

/**
* method to intercept a "successful" ajax call.  
* Check to see if the returned html is the error page, if so show the ajax popup error instead
* Otherwise call the original function as planned
*/
Util.onAjaxSuccess = function(strHtml, fnOnSuccess) {
	if (strHtml.indexOf('<ERROR') == 0) {
		Util.onAjaxError();
	} else {
		fnOnSuccess.call(this,strHtml);
	}
}


/**
 * loop through the elements in a form, putting their name & value into a string to be returned 
 */
Util.formToString = function(objForm) {
	//alert(objForm.outerHTML);
	return $(objForm).serialize(); 
	
	var strData = '';
	var strFormElement;
    for (var x=0;x<objForm.elements.length;x++) {
    	strFormElement = Util.formElementToString(objForm.elements[x]);
    	if (strFormElement != '') {
    	    strData += strFormElement; 
	    	if (x < (objForm.elements.length-1)) {
				strData += '&';
			}
		}
		/* select-one select-multiple textarea button checkbox radio file hidden image password hidden reset submit text */		
	}
	return strData;
}

Util.formElementToString = function(objFormElement) {
	var strData = '';
	if (objFormElement.type == 'checkbox' || objFormElement.type == 'radio') {
		//strData += objFormElement.name + '=' + (objFormElement.checked ? objFormElement.value : '');
		if (objFormElement.checked) strData += objFormElement.name + '=' + objFormElement.value;
	} else if (objFormElement.type == 'hidden' || objFormElement.type == 'text' || objFormElement.type == 'textarea' || objFormElement.type == 'password') {
		strData += objFormElement.name + '=' + objFormElement.value;
	} else if (objFormElement.type == 'select-one') {
		strData += objFormElement.name + '=' + objFormElement.options[objFormElement.selectedIndex].value;
	} else if (objFormElement.type == 'select-multiple') {
		for (var opt=0;opt<objFormElement.options.length;opt++) {
			if (objFormElement.options[opt].selected) {
				if (strData != '') {
					strData += '&';
				}
				strData += objFormElement.name + '=' + objFormElement.options[opt].value;
			}
		}					
	} else if (objFormElement.type == 'file') {
		// file not currently supported
	} else {
		alert('Need to finish the Form function synchFieldsWithOriginalUI to handle type: ' + objFormElement.type + '!');
	}
	return strData;
}

/**
* called when an inline popup opens, init the stuff inside the popup
*/ 
Util.initPopupForm = function(fnToCall) {
	$('#modalDiv form input:text').keypress(function(event) {
	  try {
		var code = (event.keyCode ? event.keyCode : event.which); 
		if (code==13) { // ENTER
			//alert('in keypress in the form; code: ' + code + ' form: ' + this);
			event.preventDefault();
			event.stopPropagation();
			//Util.submitForm({strFormName:this.name,bValidate:true,bPopup:true});
			fnToCall.call();			
			return;			
		}
		
	  } catch(e) {}
	});
}

Util.showPopupOld = function(strURL, intWidth, strDivName, bModal) {
	if (strDivName === undefined) {
		strDivName = 'divPopup';
	} 
	if (intWidth === undefined) {
		intWidth = 400;
	}
	Util.closePopup();
	Validator.clearValidations({strFormName:'frmPopup'});			
	// show the modal grey screen
	// put in the box, hit the server between .  position the grey filter at document height-4, otherwise the page will start scrolling on ie
	var strHtml = 
	'<div id="modalDiv" style="position:absolute;width:100%;height:' + ($(document).height() - 4) + 'px;left:0;top:0;"><div id="divOutsidePopup" style="position:absolute;width:100%;height:100%;left:0;top:0;background-color:#666666;filter:alpha(opacity=50);-moz-opacity:.50;opacity:.50;"></div>' +
	'<div id="' + strDivName + '" style="position:absolute;text-align:center;left:' + (Math.round($('body').width()/2)-Math.round(intWidth/2)) + 'px;top:' + (Util.scrollTop() + 120) + 'px;width:' + intWidth + 'px;">' +
	'</div>' +
	'</div>';

	$('body').append(strHtml);	
	
	if (strURL != null) {	
		// now request page 1 for the screen, add the "ajax=true" to the request
		strURL += (strURL.indexOf('?') > 0 ? '&' : '?') + Util.addRandomToURL('ajax=true');
		$('#' + strDivName).load(strURL);
	}
	if (bModal) {
		Util.isModalPopup = true;		
	} else {
		Util.isModalPopup = false;
	}
}

Util.closePopupOld = function() {
  if ($('#modalDiv')) {
	$('#modalDiv').remove();
  }
}


/**
* called when a form is submitted using the enter button
*/
Util.onSubmitForm = function(objForm,bPopup) {
	if (bPopup === undefined) bPopup = false;
	if (objForm.name == 'frmPopup' || objForm.id == 'frmPopup')  bPopup = true;
	// TODO: pass bPopup to the form
	Util.submitForm({strFormName:objForm.name,bPopup:bPopup,bValidate:true});	
	return false;
}


/**
* objOptions can contain: strFormName, bValidate, bPopup, bAjax, strURL, fnOnInvalid, fnOnSuccess, fnClearErrors
* bPopup assumes that bAjax is true
* TODO: what if there are two forms going, wanting to validate the popup but not the lower one?  will have to address if it comes up, 
* add to the test or check "isPopup" or something
*/
Util.submitForm = function(objOptions) {
	if (objOptions === undefined) {
		objOptions = {};
	}
	// when a form has an element named "name" (like the cosweb new group form) it causes a problem where the popup can be submitted on pressing enter
	if (objOptions.strFormName === undefined || typeof(objOptions.strFormName) !== 'string') {
		objOptions.strFormName = (objOptions.bPopup ? 'frmPopup' : 'frmMain');
	}
	if (objOptions.bValidate) {
		if (objOptions.fnClearErrors != undefined) {
			objOptions.fnClearErrors.call();
		}
		var bValid = true;
		//var strValidationMessage = 'Please complete the highlighted fields';
		// things to validate should already be registered with the validator, so can just call a validate() method
		// return if not validated	
		if (!Validator.isFormValid(objOptions.strFormName)) {
			if (objOptions.fnOnInvalid !== undefined) {
				objOptions.fnOnInvalid.call(this,Validator.errorMessage);
			} else {
				if (objOptions.bPopup) {
					$('.divErrorPopup').html(Validator.errorMessage).show();					
				} else {
					$('.divError').html(Validator.errorMessage).show();					
				}
			}
			return;
		}
	}
	
	var theForm = document.forms[objOptions.strFormName];
	var strURL = (objOptions.strURL === undefined ? theForm.action : objOptions.strURL); 
	if (objOptions.bPopup || objOptions.bAjax) {
		var strData = Util.formToString(theForm);
		strData += ((strData == '' ? '' : '&') + Util.addRandomToURL('ajax=true')); 		
		var fnOnSuccess = (objOptions.fnOnSuccess == undefined ? 
			function(html) {
				$('#modalDiv:firstChild').html(html);
			} : objOptions.fnOnSuccess);
		var fnOnError = (objOptions.fnOnError == undefined ? 
			function(XMLHttpRequest, textStatus, errorThrown) {
				Util.onAjaxError(XMLHttpRequest, textStatus, errorThrown);
			} : objOptions.fnOnError);

		$.ajax({type: 'POST',	
			url: strURL,
			data: strData,
			success: fnOnSuccess,
			error: fnOnError
		});
		
	} else {
		theForm.action = strURL;
		theForm.submit();
		// not a popup, just submit the form	
	}
}

Util.copyBodyToClipboard = function() {
	clipboardData.setData('Text', $('body').html());
	return;
}

Util.getPosition = function(objTarget) {
	var curleft = 0 + $(objTarget).offset().left;
	var curtop = 0 + $(objTarget).offset().top;
	return {x:curleft,y:curtop};
}

Util.showTab = function(whichTabGroup,whichTab) {
	$('#'+whichTabGroup+' .tabOn').removeClass('tabOn');
	$('#'+whichTabGroup+' #tab' + whichTab).addClass('tabOn'); 
	$('#'+whichTabGroup+' .tabBody').hide();
	$('#'+whichTabGroup+' #tabBody' + whichTab).show();
	//tabsSameHeight(whichTabGroup); // since the content of the tab can change as you view it, ex. by clicking to view the detail
}

Util.clearErrors = function(bPopup) {
	if (bPopup) {
		$('.modalDiv .form .error').removeClass('error');
		$('#divPopup .form .error').removeClass('error');
		$('.divErrorPopup').hide();
	} else {
		$('form .error').removeClass('error');
		$('.divError').hide();	
	}
}

/**
 * Pops up a blank popup, html to be filled in after it's open
 */
Util.showBlankPopup = function(intWidth, strPopupName, strDivName, strPopupTitle) {	
	var strHtml = 
	'<div class="popupShadow" style="width:420px;">' +
		'<div class="popupTitle"><div style="text-align:center;margin:14px;">' + strPopupTitle + '</div></div>' +
		'<div id="' + strDivName + '" style="padding:10px;text-align:left;background-color:#fff;font-size:1.2em;">' +
		'</div>' +	
		'<div class="bottomButtonDiv" style="text-align:center;">' +	
		'</div>' +
	'</div>';	
	
	Util.showPopup(null, 420, 'strPopupName', true, true);
	$('#strPopupName').html(strHtml);
}

/**
 * Pops up a confirmation box with "yes" and "no" instead of "ok" and "cancel"
 * strMessage: the text to display
 * fnOnYes: fn to call when they click the "yes" button
 * fnOnNo: fn to call when they click the "no" button
 */
Util.confirm = function(strMessage, fnOnYes, fnOnNo, bDontCloseWindow) {	
	Util.bDontCloseWindow=bDontCloseWindow;
	//alert('dont close: ' + bDontCloseWindow + '!' + Util.bDontCloseWindow);
	if (fnOnNo === undefined) {
		fnOnNo = function() {} // do nothing, the popup will close
	}
	Util.fnOnNo = fnOnNo;
	Util.fnOnYes = fnOnYes;
	
	var strHtml = 
	'<div class="popupShadow" style="width:420px;">' +
		'<div class="popupTitle"><div style="text-align:center;margin:14px;">Confirm</div></div>' +
		'<div style="padding:10px;text-align:left;background-color:#fff;font-size:1.2em;">' +
			strMessage +
		'</div>' +	
		'<div class="bottomButtonDiv" style="text-align:center;">' +	
			'<a onclick="javascript:Util.onConfirm(\'yes\')" class="adminLink" style="margin-right:25px;">Yes</a>' +	
			'<a onclick="javascript:Util.onConfirm(\'no\')" class="adminLink">No</a>' +	
		'</div>' +
	'</div>';	
	
	Util.showPopup(null, 420, 'popupConfirm', true, true);
	$('#popupConfirm').html(strHtml);
}

/**
* added the optional bCloseWindow in case need to confirm multiple things, don't want one closing the next one
*/
Util.onConfirm = function(strParam,bDontCloseWindow) {
	if ('yes' == strParam) {
		this.fnOnYes.call();
	} else {
		this.fnOnNo.call();
	}
	if (!Util.bDontCloseWindow) {
		Util.closePopup();
	}
}


Util.getCookie = function(strCookieName){
  if (document.cookie.length > 0){
	c_start = document.cookie.indexOf(strCookieName + "=");
	if (c_start != -1) { 
	  c_start = c_start + strCookieName.length + 1; 
	  c_end = document.cookie.indexOf(";",c_start);
	  if (c_end == -1) {
	  	c_end = document.cookie.length;
	  }
		return unescape(document.cookie.substring(c_start,c_end));
	} 
  }
  return '';
}

Util.setCookie = function(strCookieName,value,expiredays) {
  //if (!Util.getCookie(strCookieName)) {
	var exdate = new Date();
	exdate.setDate(exdate.getDate()+expiredays);
	document.cookie = strCookieName + '=' +escape(value)+((expiredays==null) ? '' : ';expires='+exdate.toGMTString());
  //}
}

Util.deleteCookie = function(strCookieName) {
  if (Util.getCookie(strCookieName)) {
	document.cookie = strCookieName + '=;expires=Thu, 01-Jan-70 00:00:01 GMT';
  }
}

/**
* given a string in the format mm/dd/yyyy returns a date object
*/
Util.parseDate = function(strDate) {
    if (!(
    	strDate.match(/^[0-9][0-9]?-[0-9][0-9]?-[0-9]+$/) || 
    	strDate.match(/^[0-9][0-9]?\/[0-9][0-9]?\/[0-9]+$/)
    	)) {
        return null;
    }
    var delim = (strDate.indexOf('-') > 0 ? '-' : '/');
    var arrDate = strDate.split(delim);
    try {
    	var month = parseInt(arrDate[0],10);
    	var day = parseInt(arrDate[1],10);
    	var year = parseInt(arrDate[2],10);
    	var theDate = new Date(year,month,day);
    	return theDate;
    } catch(err) {
    	return null;
    }
}

/**
* given a date object, returns a formatted string mm/dd/yyyy
*/
Util.formatDate = function(objDate) {
	return (objDate.getMonth() < 10 ? '0' : '') + objDate.getMonth() + (objDate.getDate() < 10 ? '/0' : '/') + objDate.getDate() + '/' + objDate.getFullYear();
}

Util.escapeStringForJQuery = function(str) {
	return str.replace(/\./g,'\\.').replace(/\[/g,'\\[').replace(/\]/g,'\\]').replace(/\_/g,'\\_');
}	

/**
* update the sort order of a row of something, pass in:
* upOrDown: 'UP' or 'DOWN'
* strLabel: string used in the html id's to identify these pieces, ex. 'menuItem'
* strId: the primary key of the object in the row to move (usually an int)
*/
Util.reorderItem = function(strLabel, upOrDown, strId) {
	var trItem = $('#'+strLabel+'_' + strId + '_tr');
	var hdnSortOrder = $('#'+strLabel+'_' + strId + '_sortOrder');
	var theSib = (upOrDown == 'UP' ? trItem.prev() : trItem.next()); // get the row above or below
	if (theSib === undefined || theSib[0] == undefined || theSib[0].id === undefined || theSib[0].id.indexOf(strLabel+'_') < 0) {
		return;
	}
	var theSibId = theSib[0].id.replace(strLabel+'_','').replace('_tr','');
	trItem.replaceWith('');
	if (upOrDown == 'UP') {
		trItem.insertBefore(theSib);
	} else {
		trItem.insertAfter(theSib);
	}
	
	// now update the sort orders, swap the values of the current row and the sib
	var sortOrderMenuItem = $('#'+strLabel+'_' + strId + '_sortOrder').val();
	$('#'+strLabel+'_' + strId + '_sortOrder').val($('#'+strLabel+'_' + theSibId + '_sortOrder').val());
	$('#'+strLabel+'_' + theSibId + '_sortOrder').val(sortOrderMenuItem);
}

Util.disableButton = function(btnQuery,strNewImage) {
	$(btnQuery).attr('src','/images/buttons/' + strNewImage).click(function(event) {event.preventDefault();event.stopPropagation();return false;});
}

Util.enableButton = function(btnQuery,strNewImage) {
	$(btnQuery).attr('src','/images/buttons/' + strNewImage).unbind('click');// won't cancel the event now
}

Util.disableNewButton = function(btnQuery,strNewText) {
	var objBtn = $(btnQuery);
	if (strNewText !== undefined) {
		if (objBtn.is('input')) {
			objBtn[0].value=strNewText;
		} else {
			objBtn.html(strNewText);
		}
	}
	objBtn.attr("disabled", "disabled").addClass('btn_disabled').click(function(event) {event.preventDefault();event.stopPropagation();return false;});
}

Util.enableNewButton = function(btnQuery,strNewText,fnClick) {
	var objBtn = $(btnQuery);
	objBtn.removeAttr("disabled").removeClass('btn_disabled');
	if (strNewText !== undefined) {
		if (objBtn.is('input')) {
			objBtn[0].value=strNewText;
		} else {
			objBtn.html(strNewText);
		}
	}
	if (fnClick !== undefined) {
		objBtn.click(fnClick);
	} else {
		objBtn.unbind('click');// won't cancel the event now
	}
}

Util.refreshPage = function() {
	history.go(0);
}

Util.clearHiddenAutocompleteId = function(event,strHdnFieldName) {
	var code = (event.keyCode ? event.keyCode : event.which); 
	if (code==13) { // ENTER
		return; // could be submitting the form
	}
	$('#'+strHdnFieldName).val('');
}

Util.isDatePast = function(objDate) {
    var now = new Date();
    var target = objDate;

    if (target.getFullYear() < now.getFullYear()) {
        return true;
    } else if (target.getFullYear() == now.getFullYear() && target.getMonth() < now.getMonth()) {
        	return true;
    } else if (target.getFullYear() == now.getFullYear() && target.getMonth() == now.getMonth()) {
    	return (target.getDate() < now.getDate());
    } else {
       	return false;
    }  
}

// not used
Util.isTimePast = function(strTime) {
    var now = new Date();
    var target = objDate;

    if (target.getFullYear() < now.getFullYear()) {
        return true;
    } else if (target.getFullYear() == now.getFullYear() && target.getMonth() < now.getMonth()) {
        	return true;
    } else if (target.getFullYear() == now.getFullYear() && target.getMonth() == now.getMonth()) {
    	return (target.getDate() < now.getDate());
    } else {
       	return false;
    }  
}

Util.showLoadingOverlay = function(message) {
	if(message == undefined)
		message = "Loading";
	$("#loading-overlay .loading-message").html(message);
	$("#loading-overlay").show();
}

Util.hideLoadingOverlay = function() {
	$("#loading-overlay").hide();
}

// types are: error, question, information
Util.showOptionDialog = function(type, title, message, optionType, callback, dialogName) {
	$("body").append($("<div>").addClass("fixed-popup").addClass("popup").load('/dialog/'+type, {'title':title, 'message':message,
			'optionType':optionType, 'callback':callback, 'ajax':true, 'name':dialogName }));
	Util.detectScrollToggle();    				
}

Util.showInputDialog = function(title, message, callback, defaultInput, dialogName) {
	$("body").append($("<div>").addClass("fixed-popup").addClass("popup").load('/dialog/input', {'title':title, 'message':message,
		'optionType':'INPUT', 'callback':callback, 'ajax':true, 'defaultInput':defaultInput, 'name':dialogName }));
	Util.detectScrollToggle();    				
}

/* adding in local cache for autocomplete results */
var autocomplete_cache = {};

/**
* initialize an autocomplete typeahead
* ex: Util.initAutocomplete({strInputId:'searchAuditors',strHiddenId:'hdnAuditorUserId',strURL:'/a/search/auditorsForSite/',strAddlParams:'siteId=123'})
* ,fnSelect: function(event,ui) {}
* strInputId,strHiddenId,strURL,strAddlParams,minLength,fnChange
*/
Util.initAutocomplete = function(arrParams) {
// clear id on change
   $('#'+arrParams.strInputId).keyup(function(event) {Member.clearMemberId(event,arrParams.strHiddenId)});
	$('#'+arrParams.strInputId).autocomplete({  	
		minLength: (arrParams.minLength === undefined ? 3 : arrParams.minLength),
		//change: (arrParams.fnChange === undefined ? function() {} : arrParams.fnChange),
        select: function(event, ui) {
        	if (ui.item) {
        		$('#'+arrParams.strHiddenId).val(ui.item.value);
        		$('#'+arrParams.strInputId).val(ui.item.label);
        	} else {
        		$('#'+arrParams.strHiddenId).val('');
        		$('#'+arrParams.strInputId).val('');		           
        	}
        	if (arrParams.fnSelect !== undefined) {
        		arrParams.fnSelect.call(this,event,ui);
        	}
        	if (arrParams.fnChange !== undefined) {
        		arrParams.fnChange.call(this,event,ui);
        	}
        	event.preventDefault();event.stopPropagation();return false;
        },
        source: function(request, response) {	
		   var term          = request.term.toLowerCase(),
		       element       = this.element,
		       autocomplete_cache = this.element.data('autocompleteCache') || {},
		       foundInCache  = false;
		
		    $.each(autocomplete_cache, function(key, data){
		      if (term.indexOf(key) === 0 && data.length > 0) {
		        response($.ui.autocomplete.filter(data,term).slice(0,20));
		        foundInCache = true;
		        return;
		      }
		    });
		
		    if (foundInCache) return;
        
        	//alert('url: ' + arrParams.strURL + '?' + ((arrParams.strAddlParams !== undefined && arrParams.strAddlParams != '') ? (arrParams.strAddlParams + '&') : '') + 'q='+request.term);
            //pass request to server  
			 $.ajax({
	               type: "GET",
	               url: arrParams.strURL + '?' + ((arrParams.strAddlParams !== undefined && arrParams.strAddlParams != '') ? (arrParams.strAddlParams + '&') : '') + 'q='+request.term,
	               success: function (data) {
	               		var jsonData = $.parseJSON(data);
	               		autocomplete_cache[term] = jsonData;
              			element.data('autocompleteCache', autocomplete_cache);
	            	    response(jsonData.slice(0,20));
	               },
	               error: function (msg) {
	               		// timeout or canceled call if form submitted before returning
	                   //alert(msg.status + ' ' + msg.statusText);
	               }
	        });
        }	
   }); // end autocomplete
}

Util.initFileUpload = function(aId, strFileType, intWidth, intHeight, usage) {
	if (intWidth === undefined) intWidth = 175;
	if (intHeight === undefined) intHeight = 175;
	var filePhotoUpload = new AjaxUpload(aId, {
		action: '/img/util/uploadTemp?ajax=true&fileType=' + strFileType,
		accept: 'image/*',
		name: 'uploadPhotoImage',
		autoSubmit: false,
		content: 'json',
		onChange: function(file, extension) {
			Util.showLoadingOverlay("Please Wait While We Upload Your Photo");
			filePhotoUpload.submit();
		},
		onComplete : function(file, response) {
			var failed=false;
			try {
				var jsonResponse = JSON.parse(response);
				if(jsonResponse.success != undefined) {
					Util.showPopup('/img/cropAndSavePhoto?width='+intWidth+'&height='+intHeight+'&fileType=' + strFileType + '&usage=' + usage + '&fileName=' + encodeURIComponent(jsonResponse.fileName) + '&tempName='+encodeURIComponent(jsonResponse.tempName), 700, undefined, false, false, true);
				} else {
					failed = true;
				}
			} catch(e) {
				failed = true;
			}
	
			if(failed) {
				Util.showOptionDialog('error', 'Error', 'We had a problem uploading your photo, please make sure that it is smaller than 5MB and an accepted file type.', 'OK', undefined);
			}
			Util.hideLoadingOverlay();
		},
		onError: function() {
			alert('ERROR!');
		}
	});
	return filePhotoUpload;

}

Util.viewMenu = function(menuId) {
	Util.showPopup('/dining/viewMenu?menuId=' + menuId,700);
}

Util.isVisible = function (inputObj) {
  return $(inputObj).is(":visible");
}

/**
 * ReplaceAll by Fagner Brack (MIT Licensed)
 * Replace all occurrences of a substring in a string
 */
String.prototype.replaceAll = function( token, newToken, ignoreCase ) {
    var _token;
    var str = this + "";
    var i = -1;

    if ( typeof token === "string" ) {

        if ( ignoreCase ) {

            _token = token.toLowerCase();

            while( (
                i = str.toLowerCase().indexOf(
                    token, i >= 0 ? i + newToken.length : 0
                ) ) !== -1
            ) {
                str = str.substring( 0, i ) +
                    newToken +
                    str.substring( i + token.length );
            }

        } else {
            return this.split( token ).join( newToken );
        }

    }
return str;
};

String.prototype.keepOnlyHtmlTags = function (keepOnlyTags) {
	var out = this;

	var allowedTags = keepOnlyTags;
	if (typeof(allowedTags) == "undefined") allowedTags = [];
	if (allowedTags.length > 0) {
		allowedTags = (((allowedTags||'') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('');
			 var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
						out = out.replace(tags, function($0, $1) {
			return allowedTags.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : ''
		});
	}

	return out.trim();
};

String.prototype.uppercaseTextInHtml = function () {
	var htmlString = this;
	
	// Create a DOMParser to parse the HTML string.
  var parser = new DOMParser();
  var doc = parser.parseFromString(htmlString, "text/html");

  // Recursively traverse the parsed DOM and uppercase text nodes.
  function traverse(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      node.textContent = node.textContent.toUpperCase();
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      for (var i = 0; i < node.childNodes.length; i++) {
        traverse(node.childNodes[i]);
      }
    }
  }

  // Start the traversal from the parsed document's body element.
  traverse(doc.body);

  // Create a DOMSerializer to convert the modified DOM back to an HTML string.
  var serializer = new XMLSerializer();
  var modifiedHtmlString = serializer.serializeToString(doc);

  return modifiedHtmlString;
}
